import { all, call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import { showFetchError } from '../../utils/sagaUtils';
import { ERROR, LOADING, SUCCESS } from '../../scripts/models/request-status';

import { activateToken, fetchSsoData, inspectCodeB } from './ssoActions';
import { TokenStatusResponse } from './ssoTypes';
import {
  setActivated,
  setCodeB,
  setCodeBStatus,
  setIsLoadingActivate,
  setSsoData
} from './ssoSlice';
import { activateTokenRequest, getTokenStatus, inspectCodeBRequest } from './ssoApi';

function* fetchSsoDataSaga() {
  try {
    const response: TokenStatusResponse = yield call(getTokenStatus);

    const { active: isActive, sso_enabled: ssoEnabled, access_token: accessToken } = response;

    yield put(setSsoData({ isActive, ssoEnabled, accessToken }));
  } catch (reason) {
    console.error(reason);
    yield showFetchError();
  }
}

function* activateTokenSaga(action: PayloadAction<string>) {
  try {
    yield put(setIsLoadingActivate(true));
    yield call(activateTokenRequest, action.payload);
    yield put(setActivated());
  } catch (reason) {
    console.error(reason);
    yield put(setIsLoadingActivate(false));
    yield showFetchError();
  }
}

function* inspectCodeBSaga(action: PayloadAction<string>) {
  try {
    yield put(setCodeBStatus(LOADING));

    const body = yield call(inspectCodeBRequest, action.payload);

    yield put(setCodeB({ status: SUCCESS, body }));
  } catch (reason) {
    yield put(setCodeB({ status: ERROR, body: { error: reason?.text } }));
    yield showFetchError();
  }
}

export function* ssoSagas() {
  yield all([
    takeLatest(fetchSsoData, fetchSsoDataSaga),
    takeLatest(activateToken, activateTokenSaga),
    takeLatest(inspectCodeB, inspectCodeBSaga)
  ]);
}
